import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Trash2, Save } from "lucide-react";

export default function CommercialValuesPage() {
  const [values, setValues] = useState([]);
  const [metier, setMetier] = useState("");
  const [valeur, setValeur] = useState("");

  const fetchValues = async () => {
    try {
      const res = await api.get("/commercial-values");
      setValues(res.data.items);
    } catch (e) {
      toast.error("Erreur lors du chargement des coefficients");
    }
  };

  useEffect(() => {
    fetchValues();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.put("/commercial-values", { metier, valeur: Number(valeur) });
      toast.success("Coefficient enregistre");
      setMetier("");
      setValeur("");
      fetchValues();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Erreur lors de l'enregistrement");
    }
  };

  const handleDelete = async (m) => {
    try {
      await api.delete(`/commercial-values/${m}`);
      toast.success("Coefficient supprime");
      fetchValues();
    } catch (e) {
      toast.error("Erreur lors de la suppression");
    }
  };

  return (
    <div className="p-6 space-y-6" data-testid="commercial-values-page">
      <form onSubmit={handleSubmit} className="border border-border p-6 flex flex-wrap items-end gap-4" data-testid="commercial-value-form">
        <div className="space-y-2">
          <Label className="font-mono text-xs uppercase tracking-wider">Metier</Label>
          <Input
            data-testid="commercial-value-metier-input"
            value={metier}
            onChange={(e) => setMetier(e.target.value)}
            placeholder="Ex: menuisier"
            required
            className="rounded-none"
          />
        </div>
        <div className="space-y-2">
          <Label className="font-mono text-xs uppercase tracking-wider">Valeur (0-100)</Label>
          <Input
            data-testid="commercial-value-valeur-input"
            type="number"
            min={0}
            max={100}
            value={valeur}
            onChange={(e) => setValeur(e.target.value)}
            required
            className="rounded-none w-32"
          />
        </div>
        <Button type="submit" data-testid="commercial-value-submit-button" className="rounded-none font-mono uppercase tracking-wider gap-2">
          <Save size={14} /> Enregistrer
        </Button>
      </form>

      <div className="border border-border divide-y divide-border" data-testid="commercial-values-list">
        {values.map((v) => (
          <div key={v.metier} className="p-4 flex items-center justify-between" data-testid={`commercial-value-row-${v.metier}`}>
            <span className="font-medium capitalize">{v.metier}</span>
            <div className="flex items-center gap-4">
              <span className="font-mono text-lg font-bold">{v.valeur}</span>
              <Button variant="outline" size="icon" className="rounded-none" onClick={() => handleDelete(v.metier)} data-testid={`commercial-value-delete-${v.metier}`}>
                <Trash2 size={14} />
              </Button>
            </div>
          </div>
        ))}
        {values.length === 0 && (
          <p className="p-6 text-center text-muted-foreground font-mono text-xs uppercase" data-testid="commercial-values-empty-state">
            Aucun coefficient
          </p>
        )}
      </div>
    </div>
  );
}
